import React from "react";

function article_1() {
  return {
    date: "15 June 2023",
    title: "How We Cut Cloud Costs by 60% for Kampala Tech Startups",
    description: "Proven AWS optimization strategies that helped 3 Ugandan SaaS companies reduce infrastructure spending while improving performance. Learn our cost-saving techniques.",
    keywords: [
      "Cloud cost reduction Africa",
      "AWS optimization Uganda",
      "Startup tech infrastructure",
      "Fintech cloud solutions",
      "African tech case studies",
      "Kirunda Brian cloud architect"
    ],
    style: `
      .article-content {
        max-width: 800px;
        margin: 0 auto;
        line-height: 1.6;
      }
      .case-study-box {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 8px;
        margin: 25px 0;
      }
    `,
    body: (
      <React.Fragment>
        <div className="article-content">
          <h2>Real Cloud Savings for African Startups</h2>
          
          <div className="case-study-box">
            <h3>Client: FarmConnect SaaS Platform</h3>
            <p><strong>Challenge:</strong> $3,500/month AWS bill for their agricultural analytics platform</p>
            <p><strong>Solution:</strong></p>
            <ul>
              <li>Right-sized EC2 instances using CloudWatch metrics</li>
              <li>Implemented Aurora Serverless for variable workloads</li>
              <li>Migrated static assets to CloudFront with Uganda edge locations</li>
            </ul>
            <p><strong>Results:</strong> 63% cost reduction ($1,295/month savings)</p>
          </div>

          <h3>Key Lessons for African Tech Teams</h3>
          <ol>
            <li><strong>Reserved Instances</strong> don't always pay off for variable African user patterns</li>
            <li><strong>Local caching</strong> is essential with unstable internet connections</li>
            <li><strong>Spot instances</strong> can work for batch processing jobs during off-peak hours</li>
          </ol>

          <blockquote>
            "These optimizations let us redirect funds to hiring two more developers"
            <br />- Tech Lead, FarmConnect
          </blockquote>
        </div>
      </React.Fragment>
    ),
  };
}

function article_2() {
  return {
    date: "22 July 2023",
    title: "Building AI Diagnostics for Private Clinics: Our Technical Journey",
    description: "How we developed an affordable malaria detection system for Kampala medical practices using TensorFlow.js and offline-first design principles.",
    keywords: [
      "AI for African healthcare",
      "TensorFlow.js diagnostics",
      "Private clinic technology",
      "Edge AI solutions",
      "Medical startup tech",
      "Kirunda Brian AI projects"
    ],
    style: `
      .article-content {
        font-family: 'Segoe UI', sans-serif;
        line-height: 1.7;
      }
      .tech-specs {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        margin: 20px 0;
      }
    `,
    body: (
      <React.Fragment>
        <div className="article-content">
          <h2>Democratizing Medical AI for Private Practices</h2>
          
          <h3>Client: Kampala Medical Partners (5-clinic network)</h3>
          <p><strong>Business Need:</strong> Affordable alternative to $15,000 digital microscopes</p>

          <div className="tech-specs">
            <div>
              <h4>Technical Stack</h4>
              <ul>
                <li>TensorFlow.js model (Quantized for mobile)</li>
                <li>Progressive Web App architecture</li>
                <li>Firebase for secure data sync when online</li>
              </ul>
            </div>
            <div>
              <h4>Performance Metrics</h4>
              <ul>
                <li>92% accuracy vs lab tests</li>
                <li>Works on 2G networks</li>
                <li>300MB initial download (all assets offline)</li>
              </ul>
            </div>
          </div>

          <h3>Implementation Challenges</h3>
          <p>We overcame:</p>
          <ul>
            <li><strong>Device fragmentation:</strong> Tested on 12 common Uganda smartphone models</li>
            <li><strong>Data scarcity:</strong> Partnered with 3 private labs for training images</li>
            <li><strong>Regulatory compliance:</strong> Designed as doctor decision-support tool</li>
          </ul>

          <blockquote>
            "This tool pays for itself in 2 months compared to traditional equipment"
            <br />- Dr. Musa Kato, Kampala Medical Partners
          </blockquote>
        </div>
      </React.Fragment>
    ),
  };
}

const myArticles = [article_1, article_2];

export default myArticles;